import { atom } from "recoil";
import { Card } from "../../models";

export const withAccommodations = atom({
    key: 'withAccommodations',
    default: [] as Card[]
})